export default __webpack_public_path__ + "static/media/heading.cbfffb9b.svg";